import { Reveal } from "@/components/Reveal";

export const SectionHead = ({ eyebrow, title, copy, dark = false, align = "left" }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="eyebrow" data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{eyebrow}</p>}
    <h2 className={`mt-3 font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl ${dark ? "text-white" : "text-navy-ink"}`}>
      {title}
    </h2>
    {copy && (
      <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/70" : "text-slate2"}`}>
        {copy}
      </p>
    )}
  </Reveal>
);
